module.exports = __webpack_public_path__ + "img/read-more.d6db42ee.svg";